// @ts-nocheck

import React, { useState, FunctionComponent } from 'react'
import { compose } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import renderField from 'Containers/Validation/renderField'
import { GreyBtn, WhiteGreyBtn, GreenBtn } from 'Stories/Button/Button.stories'
import { Mobile, Desktop } from 'Shared/components/Responsive'

import { PromocodePopupProps } from './PromocodePopupProp'

import {
  ButtonsBlock,
  WrapperForH4,
  WrapperForH3,
  WrapperSearchContainer,
  ModalHeaderPromocode,
  ModalSubHeaderPromocode,
  ErrorText,
  FormGroup,
} from './styles'

const PromocodePopup: FunctionComponent<PromocodePopupProps> = ({
  toggle,
  couponErrorMessage,
  handleResetCouponExist,
  modal,
  handleSubmitCoupon,
  invalid,
}) => {
  const { t } = useTranslation()
  const [promo, setPromo] = useState('')

  return (
    <>
      <Modal
        fade={false}
        className="modal-dialog modal-dialog--header promocode"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            style={{ color: '#999999' }}
            type="button"
            onClick={toggle}
          />
          <WrapperForH4>
            <ModalHeaderPromocode>
              {t('scheduleCampaignPage.PromoCode')}
            </ModalHeaderPromocode>
          </WrapperForH4>
        </div>

        <div>
          <Desktop>
            <form
              className="theme-light form promocode_form"
              onSubmit={handleSubmitCoupon}
            >
              <FormGroup className="form__form-group">
                <WrapperForH3>
                  <ModalSubHeaderPromocode>
                    {t('scheduleCampaignPage.enterPromocode')}
                  </ModalSubHeaderPromocode>
                </WrapperForH3>
                <WrapperSearchContainer className="form__form-group-field search__container">
                  {!couponErrorMessage ? (
                    <Field
                      className="form__input-field"
                      component={renderField}
                      name="coupon"
                      type="text"
                      htmlFor="coupon"
                      customClassname="form-without"
                      data-cy="coupon__input-render-field"
                      placeholder=" "
                      onChange={(e, newValue) => setPromo(newValue)}
                    />
                  ) : (
                    <Field
                      className="form__input-field"
                      component={renderField}
                      name="coupon"
                      type="text"
                      htmlFor="coupon"
                      customClassname="form-without form-with-error"
                      data-cy="coupon__input-render-field"
                      placeholder=" "
                      onChange={handleResetCouponExist}
                    />
                  )}
                </WrapperSearchContainer>
                {couponErrorMessage && (
                  <ErrorText>{couponErrorMessage}</ErrorText>
                )}
              </FormGroup>
              <ButtonsBlock>
                <WhiteGreyBtn
                  color="white"
                  style={{ padding: '0px 24px' }}
                  onClick={toggle}
                >
                  {t('scheduleCampaignPage.cancel')}
                </WhiteGreyBtn>

                {promo.length !== 0 && !couponErrorMessage && !invalid ? (
                  <GreenBtn
                    color="green"
                    style={{ padding: '0px 24px' }}
                    type="submit"
                  >
                    {t('scheduleCampaignPage.applyPromocode')}
                  </GreenBtn>
                ) : (
                  <GreyBtn
                    color="greyDisabled"
                    style={{ padding: '0px 24px' }}
                    disabled
                    type="submit"
                  >
                    {t('scheduleCampaignPage.applyPromocode')}
                  </GreyBtn>
                )}
              </ButtonsBlock>
            </form>
          </Desktop>

          <Mobile>
            <form
              className="theme-light form promocode_form"
              onSubmit={handleSubmitCoupon}
            >
              <FormGroup className="form__form-group">
                <WrapperForH3>
                  <ModalSubHeaderPromocode>
                    {t('scheduleCampaignPage.enterPromocode')}
                  </ModalSubHeaderPromocode>
                </WrapperForH3>
                <WrapperSearchContainer className="form__form-group-field search__container">
                  {!couponErrorMessage ? (
                    <Field
                      className="form__input-field"
                      component={renderField}
                      name="coupon"
                      type="text"
                      htmlFor="coupon"
                      customClassname="form-without"
                      data-cy="coupon__input-render-field"
                      placeholder=" "
                      onChange={(e, newValue) => setPromo(newValue)}
                    />
                  ) : (
                    <Field
                      className="form__input-field"
                      component={renderField}
                      name="coupon"
                      type="text"
                      htmlFor="coupon"
                      customClassname="form-without form-with-error"
                      data-cy="coupon__input-render-field"
                      placeholder=" "
                      onChange={handleResetCouponExist}
                    />
                  )}
                </WrapperSearchContainer>
                {couponErrorMessage && (
                  <ErrorText>{couponErrorMessage}</ErrorText>
                )}
              </FormGroup>
              <ButtonsBlock>
                <WhiteGreyBtn
                  color="white"
                  style={{ padding: '0px 24px' }}
                  onClick={toggle}
                >
                  {t('scheduleCampaignPage.cancel')}
                </WhiteGreyBtn>

                {promo.length !== 0 && !couponErrorMessage && !invalid ? (
                  <GreenBtn
                    color="green"
                    style={{ padding: '0px 24px' }}
                    type="submit"
                  >
                    {t('scheduleCampaignPage.applyPromocode')}
                  </GreenBtn>
                ) : (
                  <GreyBtn
                    color="greyDisabled"
                    style={{ padding: '0px 24px' }}
                    disabled
                    type="submit"
                  >
                    {t('scheduleCampaignPage.applyPromocode')}
                  </GreyBtn>
                )}
              </ButtonsBlock>
            </form>
          </Mobile>
        </div>
      </Modal>
    </>
  )
}

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export default compose<any>(
  reduxForm({
    form: 'coupon_form',
  })
)(PromocodePopup)
